import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';
import { useNftx } from '@nftx/react';
import { WithdrawLiquidityQuoteParams } from 'nftx.js';
import { useSlippagePercentage } from '@/presentation/context/settings';

const useWithdrawLiquidityQuote = ({
  percentageToWithdraw,
  tokenIds,
  userAddress,
  positionId,
}: Omit<WithdrawLiquidityQuoteParams, 'slippagePercentage'>) => {
  const {
    network,
    core: { quoteWithdrawLiquidity },
  } = useNftx();
  const slippagePercentage = useSlippagePercentage();

  return useQuery(
    [
      QueryKey.WITHDRAW_LIQUIDITY_QUOTE,
      percentageToWithdraw,
      positionId,
      tokenIds,
      userAddress,
      slippagePercentage,
    ],
    () => {
      return quoteWithdrawLiquidity({
        network,
        percentageToWithdraw,
        positionId,
        tokenIds,
        userAddress,
        slippagePercentage,
      });
    }
  );
};

export default useWithdrawLiquidityQuote;
